
import React, {FC} from 'react';
import { Badge } from 'react-bootstrap';
import { getAgeFromBirthDate } from '../../utils/dateutils';

export const Age: FC<{birth: string}> = ({birth}) => {
    return <Badge pill variant="secondary">{getAgeFromBirthDate(birth)}</Badge>;
}